<ion-grid style="max-width: 200px">
  <ion-item *ngIf="groupApp" lines="none" button (click)="goToNext()">
    <ion-label color="primary" class="ion-text-center ion-no-margin">
      {{ "catalog.go-to-next-hyper-category" | translate }}
    </ion-label>
  </ion-item>
</ion-grid>
